export default "__VITE_ASSET__0i2YXrlmspxl2a9HbIWQgw__";